<template>
    <div>
        <template v-if="window_width >= 992">

            <!-- Confirmations List -->
            <b-dropdown-item :to="confirmation_requests_route" active-class="active" :class="!user_permissions.includes('read-confirmations') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-confirmations') ? $t('permission.permission_denied', { permission: 'read-confirmations' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-confirmations')"><font-awesome-icon :icon="'check'" /> {{ $t('page.confirmations_list') }}</b-dropdown-item>
            <!-- Confirmations History -->
            <b-dropdown-item :to="confirmation_history_route" active-class="active" :class="!user_permissions.includes('read-confirmations') ? 'cursor-not-allowed' : ''"
                             v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-confirmations') ? $t('permission.permission_denied', { permission: 'read-confirmations' }) : '', customClass: 'tooltip-dark' }"
                             :disabled="!user_permissions.includes('read-confirmations')"><font-awesome-icon :icon="'history'" /> {{ $t('page.confirmations_history') }}</b-dropdown-item>
       
        </template>

        <template v-else>

            <!-- Confirmations List -->
            <b-link :to="confirmation_requests_route" active-class="active" :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-confirmations') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-confirmations') ? $t('permission.permission_denied', { permission: 'read-confirmations' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-confirmations')"><font-awesome-icon :icon="'check'" /> {{ $t('page.confirmations_list') }}</b-link>
            <!-- Confirmations History -->
            <b-link :to="confirmation_history_route" active-class="active" :class="['plus-header-accordion-links',{ 'cursor-not-allowed': !user_permissions.includes('read-confirmations') }]"
                    v-b-tooltip.hover.right="{ title: !user_permissions.includes('read-confirmations') ? $t('permission.permission_denied', { permission: 'read-confirmations' }) : '', customClass: 'tooltip-dark' }"
                    :disabled="!user_permissions.includes('read-confirmations')"><font-awesome-icon :icon="'history'" /> {{ $t('page.confirmations_history') }}</b-link>

        </template>
    </div>

</template>
<script>

import {mapGetters} from "vuex";

export default {
    mounted() {
        this.$nextTick(() => {
              window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
    },

    data: function () {
        return {
            window_width: window.innerWidth,
            confirmation_requests_route: '/confirmations/requests',
            confirmation_history_route: '/confirmations/history',
        }
    },

    methods: {
        onResize() {
            this.window_width = window.innerWidth;
        },  
    },
  computed: {
    ...mapGetters({
      user_permissions: 'User/getUserPermissions',
    }),
    permissionsReady() {
      return Array.isArray(this.user_permissions) && this.user_permissions.length > 0;
    }
  },

}

</script>